<template>
  <div>
    <create
      @closePopup="createDialog = false"
      @createData="create($event)"
      :dialog="createDialog"
      :loader="createLoader"
    />
    <edit
      @closePopup="editDialog = false"
      @editData="edit($event)"
      :dialog="editDialog"
      :dialogData="dialogData"
      :loader="editLoader"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteItem($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
      :loader="deleteLoader"
    />
    <teacher-filter
      @getData="setFilterData($event)"
      @clearData="clearFilterData"
    />
    <v-row class="mb-4">
      <v-col class="d-flex justify-start"
        ><v-btn color="#007bff" @click="createAble"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :data="tableData.data"
      :editable="editAble"
      :deleteable="deleteAble"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import { Users } from "@/store/common/users/teacher";
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
import teacherFilter from "./filter.vue";
export default {
  components: {
    dataTable,
    create,
    edit,
    deletePopup,
    teacherFilter,
  },
  data() {
    return {
      Users,
      createDialog: false,
      editDialog: false,
      dialogData: null,
      deleteDialog: false,
      deleteDialogData: null,
      filterData: {},
    };
  },
  methods: {
    getData(page) {
      Object.assign(this.filterData, { page: page });
      Users.get(this.filterData);
    },

    //filter
    setFilterData(data) {
      this.filterData = data;
      this.getData(1);
    },
    clearFilterData() {
      this.filterData = {};
      this.getData(1);
    },

    //create
    createAble() {
      this.createDialog = true;
    },
    async create(data) {
      await Users.post(data);
      this.createDialog = false;
    },

    //edit
    editAble(obj) {
      this.editDialog = true;
      let item = {
        id: obj.id,
        name: obj.name,
        password: obj.password,
        username: obj.user.username,
        email: obj.user.email,
      };
      this.dialogData = item;
    },
    async edit(data) {
      await Users.edit(data.data, data.id);
      this.editDialog = false;
    },

    //delete
    deleteAble(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    async deleteItem(id) {
      await Users.deleteItem(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    //data
    tableData() {
      return Users.tableData;
    },
    pagination() {
      return Users.tableData.meta;
    },
    //loaders
    loader() {
      return Users.getState.loading;
    },
    createLoader() {
      return Users.postState.loading;
    },
    editLoader() {
      return Users.editState.loading;
    },
    deleteLoader() {
      return Users.deleteState.loading;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
